import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, isRef as _isRef, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "will-change-transform" }
const _hoisted_2 = { class: "text-muted" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

import {computed, getCurrentInstance, onMounted, onUpdated} from 'vue';
import SideMenuInfo
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/SideMenuInfo.vue";
import SideMenuTargetReasons
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/SideMenuTargetReasons.vue";
import DateHelper from "~/ts/library/Date";
import {__} from "~/ts/library/Translate";
import StringHelper from "~/ts/library/StringHelper";
import CoreUiClientInfoRow from "~/core-ui/vue/chat/CoreUiClientInfoRow.vue";
import SideMenuCard from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCard.vue";
import Dictionary from "~/ts/library/Dictionary";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";


import {ref} from 'vue';

let clientInfoCollapsed = ref(false);


const __default__ = {
    name: "ClientInfo"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    site: {},
    integrationPlatformDictionary: {},
    clientDevices: {},
    canEdit: { type: Boolean },
    locationLanguage: { default: "ru" },
    ipInfoUrl: { default: "https://2ip.ru/whois/?ip=[ip]" },
    staticServer: { default: "" },
    removeTargetReason: {}
  },
  setup(__props: any) {

let props = __props;

let instance = getCurrentInstance();
let isVisible = ref(false);

function checkVisibility() {
    isVisible.value = !!instance.proxy.$el.querySelector(".el-card > .el-card__body > *");
}

let countryFlag = computed(() => {
    let location = props.userdata.location;
    return location && location.country ? `${props.staticServer}/cabinet/assets/images/flags/${location.country.code}.png` : null;
});

let clientTime = computed(() => {
    let timeZone = props.userdata.utcTimeZone;
    if (typeof timeZone == "number") {
        let dateHelper = new DateHelper(DateHelper.nowEverySecond);
        let dateObject = dateHelper.dateObject
        let offset = dateObject.getTimezoneOffset() / 60;
        dateObject.setTime(dateObject.getTime() + (timeZone + offset) * 3600000);
        let result = dateHelper.toMysqlFormatTime();
        if (!OperatorApplicationConfigInstance.showSecondsInChat) {
            result = result.substring(0, 5)
        }
        return result;
    }
    return null;
});

let device = computed(() => {
    let deviceId = props.userdata.device;
    return deviceId ? props.clientDevices.find(device => device.id == deviceId) : null;
});



let integrationPlatform = computed(() => {
    let integration = props.userdata.integration;
    if (integration) {
        return props.integrationPlatformDictionary[integration.platformId];
    }
    return null;
});


let ipInfoUrl = computed(() => {
    let ip = props.userdata.location.ip;
    if (ip) {
        let url = props.ipInfoUrl;
        if (url) {
            return StringHelper.replaceVariables(url, {
                ip
            });
        }
    }
    return null;
});

onMounted(() => checkVisibility());

onUpdated(() => checkVisibility());


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SideMenuCard, {
    ref: "root",
    class: _normalizeClass({'info': true, 'd-none': !_unref(isVisible)}),
    collapsed: _unref(clientInfoCollapsed),
    "onUpdate:collapsed": _cache[0] || (_cache[0] = ($event: any) => (_isRef(clientInfoCollapsed) ? (clientInfoCollapsed).value = $event : clientInfoCollapsed = $event))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(__)('Информация')), 1)
    ]),
    default: _withCtx(() => [
      (_unref(clientTime))
        ? (_openBlock(), _createBlock(SideMenuInfo, {
            key: 0,
            icon: "clock"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(clientTime)), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!__props.site.isFree)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_unref(integrationPlatform) && _unref(integrationPlatform).messengerPlatformData && __props.userdata.integration.clientInfo)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(integrationPlatform).messengerPlatformData.userInfo, (row) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: row.id
                  }, [
                    (__props.userdata.integration.clientInfo[row.id])
                      ? (_openBlock(), _createBlock(SideMenuInfo, {
                          key: 0,
                          icon: row.icon,
                          truncate: ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(row.descr), 1),
                            _createVNode(CoreUiClientInfoRow, {
                              value: __props.userdata.integration.clientInfo[row.id]
                            }, null, 8, ["value"])
                          ]),
                          _: 2
                        }, 1032, ["icon"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              : _createCommentVNode("", true),
            (__props.userdata.utm)
              ? (_openBlock(), _createBlock(SideMenuInfo, {
                  key: 1,
                  icon: "tag",
                  truncate: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.userdata.utm, (value, key) => {
                      return (_openBlock(), _createElementBlock("div", { key: key }, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(key) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(value), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(countryFlag))
              ? (_openBlock(), _createBlock(SideMenuInfo, {
                  key: 2,
                  image: _unref(countryFlag)
                }, {
                  default: _withCtx(() => [
                    (__props.userdata.location.city)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.userdata.location.city[__props.locationLanguage]), 1))
                      : _createCommentVNode("", true),
                    (__props.userdata.location.region && (!__props.userdata.location.city || __props.userdata.location.city.ru !== __props.userdata.location.region.ru))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.userdata.location.region[__props.locationLanguage]), 1))
                      : _createCommentVNode("", true),
                    (__props.userdata.location.country)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.userdata.location.country[__props.locationLanguage]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["image"]))
              : _createCommentVNode("", true),
            (__props.userdata.location && __props.userdata.location.ip)
              ? (_openBlock(), _createBlock(SideMenuInfo, {
                  key: 3,
                  icon: "wifi"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ipInfoUrl) ? 'a' : 'span'), {
                      target: "_blank",
                      href: _unref(ipInfoUrl)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.userdata.location.ip), 1)
                      ]),
                      _: 1
                    }, 8, ["href"]))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.userdata.browser)
              ? (_openBlock(), _createBlock(SideMenuInfo, {
                  key: 4,
                  icon: "compass"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.userdata.browser.name) + " " + _toDisplayString(__props.userdata.browser.version) + _toDisplayString(__props.userdata.browser.navigatorLanguage ? ` (${__props.userdata.browser.navigatorLanguage})` : '') + ", " + _toDisplayString(__props.userdata.browser.platform), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(device))
              ? (_openBlock(), _createBlock(SideMenuInfo, {
                  key: 5,
                  icon: _unref(device).icon
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(device).descr) + " ", 1),
                    (__props.userdata.browser && __props.userdata.browser.resolution)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(", " + _toDisplayString(__props.userdata.browser.resolution.width) + "px × " + _toDisplayString(__props.userdata.browser.resolution.height) + "px ", 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["icon"]))
              : _createCommentVNode("", true),
            (__props.userdata.targetReasons.length)
              ? (_openBlock(), _createBlock(SideMenuInfo, {
                  key: 6,
                  icon: "crosshairs",
                  truncate: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(SideMenuTargetReasons, {
                      userdata: __props.userdata,
                      "can-edit": __props.canEdit,
                      "remove-target-reason": __props.removeTargetReason
                    }, null, 8, ["userdata", "can-edit", "remove-target-reason"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (__props.site.isFree)
        ? (_openBlock(), _createBlock(SideMenuInfo, {
            key: 2,
            icon: "frown"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(__)("Информация об источнике перехода, перемещению по сайту и местоположению посетителя недоступна в бесплатной версии.")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "collapsed"]))
}
}

})